import Table from "@/common/components/Table";
import { companyGovernmentAllocationsTableColumns } from "@/features/privateCompanies/constants/companyGovernmentAllocationTableColumns.constant";
import { CompanyGovernmentAllocationTransformer } from "@/features/privateCompanies/services/companyGovernmentAllocationsTransformer";
import { CompanyGovernmentAllocationData } from "@/features/privateCompanies/types/companyGovernmentAllocation.type";
import { useParams } from "react-router-dom";

interface GovernmentAllocationTableViewProps {
  companyGovernmentAllocationsIsPending: boolean;
  companyGovernmentAllocations: CompanyGovernmentAllocationData[];
}

const GovernmentAllocationTableView = ({
  companyGovernmentAllocationsIsPending,
  companyGovernmentAllocations,
}: GovernmentAllocationTableViewProps) => {
  const { id: companyId } = useParams();

  return (
    <Table
      className="max-h-[calc(100vh-264px)] shadow-[0px_0px_8px_4px_rgba(0,_0,_0,_0.2)]"
      headerCellClassName="min-w-[60px]"
      isLoadingData={companyGovernmentAllocationsIsPending}
      columns={companyGovernmentAllocationsTableColumns}
      rows={CompanyGovernmentAllocationTransformer.tableTransformer(companyGovernmentAllocations, companyId || '', "Admin::Billing::GovernmentAllocationEntries::Show")}
      page={1}
      rowEmptyValue=""
      totalPages={1}
    />
  );
};

export default GovernmentAllocationTableView;
